/**
 * Layout-Route: /_auth/hotspots — W1.4
 *
 * Parent-Route fuer alle Hotspots-Unterseiten.
 * Rendert HotspotsLayout mit Tab-Navigation Liste/Karte.
 */
import { createFileRoute } from '@tanstack/react-router'
import { HotspotsLayout } from '../features/hotspots/HotspotsLayout'

export const Route = createFileRoute('/_auth/hotspots')({
  component: HotspotsLayout,
})
